import loadable from '@loadable/component';

// Lazy-loaded: react-player is a large bundle (browser-only)
export const VideoPlayer = loadable(
  () => import(/* webpackChunkName: "VideoPlayer" */ './VideoPlayer')
);

export { default as translations } from './translations.json';
